<template>
    <div :class="classes" role="dialog">
        <Overlay @click="onClose"/>
        <div class="content" v-bind="$attrs">
            <img class="close" src="../../assets/img/cross.svg" alt="X" @click="onClose"/>
            <main>
                <slot/>
            </main>
            <footer v-if="$slots.footer">
                <slot name="footer"/>
            </footer>
        </div>
    </div>
</template>
<script>
import Overlay from '../../components/lib/Overlay';

export default {
    name: 'Modal',
    components: { Overlay },
    inheritAttrs: false,
    props: {
        small: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        classes () {
            return {
                modal: true,
                small: this.small,
            };
        },
    },
    methods: {
        onClose () {
            this.$emit('close');
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.modal {
    @include cover();
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;

    > .content {
        position: relative;
        border-radius: 10px;
        background-color: $white;
        box-shadow: 20px 12px 28px 0 rgba($black, .1);
        max-width: 90%;

        > main {
            @include modal(32px);

        }

        > .close {
            @include square(32px);
            position: absolute;
            top: 0;
            right: 0;
            cursor: pointer;
        }

        @include breakpoint-min(sm) {
            width: 500px;
        }

        @include breakpoint-min(md) {
            width: 600px;
        }

        @include breakpoint-min(lg) {
            width: 800px;
        }
    }

    &.small {
        > .content {
            @include breakpoint-min(xs) {
                width: 400px;
            }

            @include breakpoint-min(md) {
                width: 500px;
            }
        }
    }
}
</style>
